import { render, staticRenderFns } from "./FormFieldDate.vue?vue&type=template&id=324f107b&"
import script from "./FormFieldDate.vue?vue&type=script&lang=js&"
export * from "./FormFieldDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports